// --- REPLACE WITH YOUR ACTUAL NETSUITE SUITELET EXTERNAL URL ---
var NETSUITE_API_URL = "https://560765.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=3664&deploy=1&compid=560765&ns-at=AAEJ7tMQuEQy45guImAQYQqbC4ap7vhDw4BlQMHCLkNIh0dYG2g";

function submitShippingEstimationRequest() {
    $(".div_row_freight_estimation_results").removeClass("show");
    $(".div_freight_estimation_results table tbody").html("");
    
    var validationResult = validateRequiredFormInputs();
    if (!validationResult) {
        console.log("validationResult", validationResult);
        return false;
    }
    
    // We send a raw JSON object so NetSuite parses it safely through CORS
    var requestData = {
        action: "shopify_estimate", // Tells the NetSuite Suitelet which function to run
        zip: $("input[name=zip_shipping_estimate]").val(),
        quantity: $("input[name=quantity_shipping_estimate]").val(),
        id: $("input[name=product_id]").val()
    };
    
    console.log("Shipping Estimate Data sent to NetSuite", requestData);
    $(".div_row_spinner_freight_estimate").toggleClass("show");
    
    $.ajax({
        type: "POST",
        url: NETSUITE_API_URL, 
        data: JSON.stringify(requestData), // Stringify the payload
        contentType: "application/json",
        dataType: "json",
        crossDomain: true, // Enables cross origin request to NetSuite
        success: function(data) {
            $(".div_row_spinner_freight_estimate").removeClass("show");
            console.log("NetSuite API Response", data);
            
            if (data.success && data.data && data.data.length > 0) {
                $(".div_row_freight_estimation_results").addClass("show");
                fillTheEstimateTable(data.data);
            } else {
                $(".div_row_freight_estimation_results").removeClass("show");
                var errorMsg = data.error ? data.error : "No rates returned for this zip code.";
                console.log("NetSuite API Error:", errorMsg);
                alert("Shipping Estimate Failed: " + errorMsg);
            }
        },
        error: function(err) {
            $(".div_row_spinner_freight_estimate").removeClass("show");
            $(".div_row_freight_estimation_results").removeClass("show");
            console.log("submit-freight data error", err);
            alert("Error connecting to the NetSuite Shipping API.");
        }
    });
    
    console.log("Shipping Estimation Call completed");
}

function validateRequiredFormInputs() {
    $(".missing_data").each(function() {
        $(this).removeClass("missing_data");
    });
    
    var zip = $("input[name=zip_shipping_estimate]").val();
    if (!/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip)) {
        $("input[name=zip_shipping_estimate]").addClass("missing_data");
    }
    
    var quantity = $("input[name=quantity_shipping_estimate]").val();
    if (!/^\d+$/.test(quantity)) {
        $("input[name=quantity_shipping_estimate]").addClass("missing_data");
    }
    
    var validForm = $(".missing_data").length == 0;
    validForm ? $(".div_missing_data_in_fields").removeClass("shown") : $(".div_missing_data_in_fields").addClass("shown");
    return validForm;
}

function fillTheEstimateTable(data) {
    $(".div_freight_estimation_results table tbody").html("");
    
    // Loops through the exact array formatted by NetSuite and prints it in HTML
    data.forEach(function(element) {
        var row = "<tr>";
        row += '<td class="td_shipping_estimate_carrier">' + element.shipper + "</td>";
        row += '<td class="td_shipping_estimate_type">' + element.service_name + "</td>";
        // NetSuite has already applied the 1.7 modifier!
        // Your existing HTML structure expects us to prepend the '$' symbol here.
        row += '<td class="td_shipping_estimate_quote" style="text-align: right;">$' + element.formatted_total_charge + "</td>";
        row += "</tr>";
        
        $(".div_freight_estimation_results table tbody").append(row);
    });
}